import React, { useEffect, useMemo } from "react";
import { io } from "socket.io-client";
import { socketUrl } from "../axios"; // Make sure socketUrl is the correct path to your socket server

const Context = React.createContext(null);

const SocketContext = ({ children }) => {
  const socket = useMemo(
    () =>
      io(socketUrl, {
        withCredentials: true,  // Ensures credentials (like cookies) are sent
        transports: ["polling", "websocket"],  // Try polling first, then websocket (more reliable)
        autoConnect: false,  // Disable auto-connect for manual connection control
        reconnection: true,  // Enable automatic reconnection
        reconnectionDelay: 1000,  // Wait 1 second before reconnecting
        reconnectionAttempts: 10,  // Try to reconnect 10 times
        timeout: 20000,  // Connection timeout
        forceNew: false,  // Reuse existing connection if available
      }),
    [socketUrl]
  );

  useEffect(() => {
    // Connect to the socket server manually
    socket.connect();

    // Listen for connection events
    socket.on("connect", () => {
      console.log("Socket.IO connected:", socket.id);
    });

    // Handle socket disconnection
    socket.on("disconnect", (reason) => {
      console.log("Socket.IO disconnected:", reason);
      // Only reconnect if it wasn't a manual disconnect
      if (reason === "io server disconnect") {
        // Server disconnected, reconnect manually
        socket.connect();
      }
    });

    // Listen for errors
    socket.on("connect_error", (err) => {
      console.error("Socket.IO connection error:", err.message);
      // Don't spam console with errors if server is not running
      if (err.message !== "websocket error") {
        console.error("Socket.IO full error:", err);
      }
    });

    // Handle reconnection attempts
    socket.on("reconnect", (attemptNumber) => {
    });

    socket.on("reconnect_error", (err) => {
    });

    socket.on("reconnect_failed", () => {
    });

    // Cleanup on unmount
    return () => {
      socket.disconnect();
    };
  }, [socket]);

  return <Context.Provider value={{ socket }}>{children}</Context.Provider>;
};

export const useSocketContext = () => {
  return React.useContext(Context);
};

export default SocketContext;
